// Home.js

import React from "react";
import { useCallback, useEffect, useReducer, useRef, useState } from "react";
import { Text, View } from "react-native";
import { DisplayStatus, ScreenLoading } from "components/Partials/Status";
import { stateReducer } from "components/helpers/stateReducer";
import { Feather } from "@react-native-vector-icons/feather";  // https://feathericons.com/?query=
import Button from "components/Partials/Buttons";

const Home = function () {
	const _theme = window.main.theme;
	const userProfile = window.main.lib.getUserProfile();
	return (
		<View style={{..._theme.container,padding:(window.main.platform_os==="web"?20:14)}}>
			<View style={{paddingBottom:30}}>
				<Text style={_theme.normalText}>{(`${userProfile.firstname||""} ${userProfile.lastname||""}`).trim()||"Guest Account"}</Text>
			</View>

			<View style={{..._theme.containerLiner}}>
				<Text style={_theme.normalText}>First Name: {userProfile.firstname||"--"}</Text>
			</View>
			<View style={{..._theme.containerLiner}}>
				<Text style={_theme.normalText}>Last Name: {userProfile.lastname||"--"}</Text>
			</View>
			<View style={{..._theme.containerLiner}}>
				<Text style={_theme.normalText}>Email: {userProfile.email||"--"}</Text>
			</View>
			<View style={{..._theme.containerLiner}}>
				<Text style={_theme.normalText}>Phone: {userProfile.phone||"--"}</Text>
			</View>
		</View>
	);
};

export default Home;
